import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "8",
  height: "8",
  fill: "none",
  viewBox: "-1 -1 10 10"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.756 1.223A.7.7 0 0 1 7.27 1c.19.002.373.085.51.232a.85.85 0 0 1 .22.556.86.86 0 0 1-.193.568L3.89 7.741a.7.7 0 0 1-.24.188.68.68 0 0 1-.82-.166L.234 4.907a.8.8 0 0 1-.17-.262.88.88 0 0 1 .152-.902.7.7 0 0 1 .244-.178.68.68 0 0 1 .576.011q.136.067.239.188L3.33 6.022l3.408-4.775.02-.024z"
    }, null, -1)
  ])))
}
export default { render: render }